import { gql } from "@apollo/client"
import { CONTRACT_FRAG } from "./vehicle-management.fragments.gql"

export const VEHICLE_MANGEMENT_DETAILS = gql`
  query VehicleManagementVehicleDetails($id: ID) {
    vehicleDetails(vehicleId: $id) {
      id
      registrationNumber
      modelName
      dateBought
      chassisNumber
      fuelTankCapacity
      estimatedAverage
      contracts {
        ...ContractFrag
      }
      currentContract {
        ...ContractFrag
      }
      vehicleType {
        id
        name
        category
        capacity
        capacityUnit {
          id
          name
        }
      }
      owner {
        id
      }
      driver {
        id
      }
    }
  }
  ${CONTRACT_FRAG}
`
export const VEHICLE_OWNER_DRIVER_DETAILS = gql`
  query VehicleManagementOwnerDriverDetails($id: Int) {
    userDetails(userId: $id) {
      id
      fullName
      number
      email
      customerId
      dateOfBirth
      address {
        id
        village
        taluka
      }
      kycDetails {
        id
        photo
        idNumber
        kycType {
          id
          name
        }
      }
      bankDetails {
        id
        accountNumber
        accountHolderName
        ifscCode
        branchName
        bank {
          id
          name
        }
      }
      licenceDetails {
        id
        idNumber
        validTill
      }
    }
  }
`

export const CONTRACT_EXPENSES = gql`
  query ContractExpenses($contractId: ID!) {
    contractExpenses(contractId: $contractId) {
      id
      quantity
      createdAt
      quantityRate
      netAmount
      borneBy
      resourceUsed
      expenseType {
        id
        name
      }
    }
  }
`

export const CONTRACT_PAYMENTS = gql`
  query ContractPayments($contractId: ID!) {
    contractPayments(contractId: $contractId) {
      id
      createdAt
      amount
      transactionType
      paidTo {
        id
        fullName
      }
      paymentType {
        id
        name
      }
    }
  }
`
